import React from 'react';

import { CmFlex, CmIconButton, CmText, CmTooltip } from '@/components/uiParts';
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@/components/uiParts';

interface Props {
  totalNum: number;
  currentPage: number;
  toFirstPage: () => void;
  toNextPage: () => void;
  toPreviousPage: () => void;
  toLastPage: () => void;
  LimitPerPage: number;
}

export const CmHeadingPagination: React.VFC<Props> = ({
  totalNum,
  currentPage,
  toFirstPage,
  toLastPage,
  toNextPage,
  toPreviousPage,
  LimitPerPage,
}) => {
  if (totalNum === 0) return <></>;

  const isFirstPage = currentPage === 1;
  const totalPage = Math.ceil(totalNum / LimitPerPage);
  const isLastPage = currentPage === totalPage;

  return (
    <CmFlex justifyContent="space-between" alignItems="center" w={300}>
      <CmFlex>
        <CmTooltip hasArrow={false} label="First Page">
          {/*
           // @ts-ignore TS2590 */}
          <CmIconButton
            onClick={toFirstPage}
            isDisabled={isFirstPage}
            icon={<ArrowLeftIcon h={3} w={3} />}
            mr={4}
            aria-label="First Page"
          />
        </CmTooltip>
        <CmTooltip hasArrow={false} label="Previous Page">
          <CmIconButton
            onClick={toPreviousPage}
            isDisabled={isFirstPage}
            icon={<ChevronLeftIcon h={6} w={6} />}
            aria-label="Previous Page"
          />
        </CmTooltip>
      </CmFlex>

      <CmFlex alignItems="center">
        <CmText mx={4}>
          <CmText fontWeight="bold" as="span" mr={2}>
            {currentPage}
          </CmText>
          /
          <CmText fontWeight="bold" as="span" ml={2}>
            {totalPage}
          </CmText>
        </CmText>
      </CmFlex>

      <CmFlex>
        <CmTooltip hasArrow={false} label="Next Page">
          <CmIconButton
            onClick={toNextPage}
            isDisabled={isLastPage}
            icon={<ChevronRightIcon h={6} w={6} />}
            aria-label="Next Page"
          />
        </CmTooltip>
        <CmTooltip hasArrow={false} label="Last Page">
          <CmIconButton
            onClick={toLastPage}
            isDisabled={isLastPage}
            icon={<ArrowRightIcon h={3} w={3} />}
            ml={4}
            aria-label="Last Page"
          />
        </CmTooltip>
      </CmFlex>
    </CmFlex>
  );
};
